import React, { useContext } from 'react';
export const NativeCapabilitiesContext = React.createContext({
    hapticFeedback: {
        impactOccurred: (_) => { },
    },
});
export const useHapticFeedback = () => {
    const ctx = useContext(NativeCapabilitiesContext);
    return ctx.hapticFeedback;
};
//# sourceMappingURL=index.js.map